import gql from 'graphql-tag';
import { serviceOrderFragment } from './fragments';

export const serviceOrdersByCondominium = gql`
  query serviceOrdersByCondominium($condominiumId: ID!) {
    serviceOrdersByCondominium(condominiumId: $condominiumId) {
      serviceOrders {
        ...serviceOrderParts
      }
    }
  }
  ${serviceOrderFragment}
`;

export const serviceOrderById = gql`
  query serviceOrderById(
    $serviceOrderId: ID!
    $condominiumPersonContextId: ID!
  ) {
    serviceOrderById(
      serviceOrderId: $serviceOrderId
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      serviceOrder {
        ...serviceOrderParts
      }
    }
  }
  ${serviceOrderFragment}
`;

export const serviceOrderSummaryById = gql`
  query serviceOrderSummaryById(
    $serviceOrderId: ID!
    $condominiumPersonContextId: ID!
  ) {
    serviceOrderById(
      serviceOrderId: $serviceOrderId
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      serviceOrder {
        id
        description
        startDate
        type {
          label
        }
        currentStatus {
          label
        }
        technician {
          name
        }
      }
    }
  }
`;

export const serviceOrderDefects = gql`
  query serviceOrderDefects {
    serviceOrderDefects {
      id
      description
    }
  }
`;

export const serviceOrderDefectGroups = gql`
  query serviceOrderDefectGroups {
    serviceOrderDefectGroups {
      id
      description
    }
  }
`;

export const serviceOrderTechnicians = gql`
  query serviceOrderTechnicians($condominiumPersonContextId: ID!) {
    serviceOrderTechnicians(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      id
      description
    }
  }
`;

export const serviceOrderCondominiumPlaces = gql`
  query serviceOrderCondominiumPlaces($condominiumPersonContextId: ID!) {
    serviceOrderCondominiumPlaces(
      condominiumPersonContextId: $condominiumPersonContextId
    ) {
      id
      description
    }
  }
`;
